import * as types from "../constants/actionTypes";

export const careGapsInitialState = function () {
    return {
        selectedMammographyOption: null,
        mammographyFlowFormInputs: null,
        postMammographyDataResult: null,
        selectedNoMammographyReason: null,
        postMammographyDataPending: false,
        careGapsSessionId: '',
        selectedNoMammographyData: null,
        
        selectedCareGapOption: null,
        selectedNoCareGapReason: null,
        postCareGapDataPending: false,
        selectedNoCareGapData: null,
        postCareGapDataResult: null,
        careGapFlowFormInputs: null,
        careGapProcedureType: null,
        schedulingPermissions: {},
    }
};

export default function careGapReducer(state = careGapsInitialState(), action) {
    switch (action.type) {

        case types.UPDATE_MAMMOGRAPHY_FLOW_SELECTED_OPTION:
            return {
                ...state, selectedMammographyOption: action.selectedOption
            }
        case types.CLEAR_MAMMOGRAPHY_FLOW_SELECTED_OPTION:
            return {
                ...state, selectedMammographyOption: null, mammographyFlowFormInputs:null 
            }
        case types.UPDATE_MAMMOGRAPHY_FLOW_FORM_INPUTS:
            return {
                ...state, mammographyFlowFormInputs: action.formInputs
            }
        case types.POST_MAMMOGRAPHY_FLOW_DATA_STATUS:
            return {
                ...state, postMammographyDataResult:action.result, postMammographyDataPending: false,
            }
        case types.UPDATE_NO_MAMMOGRAPHY_FLOW_SELECTED_REASON:
            return {
                ...state, selectedNoMammographyReason: action.reason, selectedNoMammographyData: action.selectedData
            }
        case types.CLEAR_MAMMOGRAPHY_DATA_AFTER_SUBMIT:
            return {
                ...careGapsInitialState()
            }
        case types.GET_MAMMOGRAPHY_FLOW_DATA:
            return {
                ...state, postMammographyDataPending: true, postMammographyDataResult: null
            }
        case types.SAVE_CAREGAPS_SESSION_ID:
            return {
                ...state, careGapsSessionId: action.careGapsSessionId
            }
        case types.CLEAR_MAMMOGRAPHY_DATA_AFTER_ONCHANGE:
            return {
                ...careGapsInitialState(), careGapsSessionId: action.careGapsSessionId
            }

         // CAREGAP FLOW RELATED ACTIONS TYPES

        case types.UPDATE_CAREGAP_SELECTED_OPTION:
            return {
                ...state, selectedCareGapOption: action.selectedOption, careGapProcedureType: action.procedureType
            }
        case types.CLEAR_CAREGAP_DATA_AFTER_ONCHANGE:
            return {
                ...careGapsInitialState(), careGapsSessionId: action.careGapsSessionId, schedulingPermissions: { ...state.schedulingPermissions }
            }
        case types.UPDATE_NO_CAREGAP_FLOW_SELECTED_DATA:
            return {
                ...state, selectedNoCareGapReason: action.reason, selectedNoCareGapData: action.selectedData, careGapProcedureType: action.procedureType
            }
        case types.GET_CAREGAP_FLOW_DATA:
            return {
                ...state, postCareGapDataPending: true, postCareGapDataResult: null
            }
        case types.UPDATE_CAREGAP_FLOW_FORM_INPUTS:
            return {
                ...state, careGapFlowFormInputs: action.formInputs, careGapProcedureType: action.procedureType
            }
        case types.CLEAR_CAREGAP_DATA_AFTER_SUBMIT:
            return {
                ...careGapsInitialState()
            }
        case types.POST_CAREGAP_FLOW_DATA_STATUS:
            return {
                ...state, postCareGapDataResult: action.result, careGapProcedureType: action.procedureType, postCareGapDataPending: false, 
            }
        case types.GET_PATIENT_SCHEDULING_PERMISSIONS_START:
            return {
                ...state,
                schedulingPermissions: {
                    loadedSchedulingPermissions: false,
                    isFetching: true,
                    error: null
                }
            }
        case types.GET_PATIENT_SCHEDULING_PERMISSIONS_SUCCESS:
            return {
                ...state,
                schedulingPermissions: {
                    ...action.schedulingPermissions,
                    loadedSchedulingPermissions: true,
                    isFetching: false,
                    error: null
                }
            }
        case types.GET_PATIENT_SCHEDULING_PERMISSIONS_FAILURE:
            return {
                ...state,
                schedulingPermissions: {
                    loadedSchedulingPermissions: false,
                    isFetching: false,
                    error: action.error
                }
            }
        default:
            return { ...state };
    }
}

